export default __webpack_public_path__ + "static/media/Metropolis-ExtraLight.d1784bd8.otf";